import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Affix, Button } from 'antd';
import "./index.less";
import logo from "../../static/images/logo.png"
export default function Header(props) {
	const [top, setTop] = useState(0);
	return (
	<>
	<div className="topBox">
		<Affix offsetTop={top}>
		<div className="header">
			<div className="container">
				<div className="logo">
					<Link to="/"><img src={logo} height={54} /></Link>
				</div>
				<div className="menu">
					<ul className="navbar_nav">
						<li className="dropdown"><Link to="/" className="link">首页</Link></li>
						<li className="product">
							<Link to="/syster" className="link">产品与服务</Link>
							<ul className="product-ul">
								<li><Link to="/syster">招标采购交易数智化系统平台、产品应用场景</Link></li>
								<li><Link to="/cloud">云产品与服务</Link></li>
								<li><Link to="/aimodel">垂类智能模型</Link></li>
								<li><Link to="/addvalue">增值赋能服务</Link></li>
							</ul>
						</li>
						<li className="about">
							<Link to="/about" className="link">关于我们</Link>
							<ul className="about-ul">
								<li><Link to="/about">公司简介</Link></li>
								<li><Link to="/zhishi">知识产权</Link></li>
								<li><Link to="/rongyu">荣誉证书</Link></li>
								<li><Link to="/news">公司新闻</Link></li>
								<li><Link to="/huoban">合作与服务</Link></li>
								<li><Link to="/joinus">加入我们</Link></li>
								<li><Link to="/contact">联系我们</Link></li>
							</ul>
						</li>
						<li className="dropdown"><Link className="link">会员服务</Link></li>
					</ul>
				</div>
			</div>
		</div>
		</Affix>
		</div>
	</>
	);
}
